import { cn } from '@/lib/utils';
import type { PnDesfechoLead } from '@/hooks/useLeadsCarteira';

interface SeloPnPedidoProps {
  desfecho?: PnDesfechoLead | null;
  className?: string;
}

export function SeloPnPedido({ desfecho, className }: SeloPnPedidoProps) {
  if (!desfecho || desfecho.total <= 0 || desfecho.concluidas <= 0) return null;

  const texto = desfecho.completo ? 'PN' : `PN ${desfecho.concluidas}/${desfecho.total}`;
  const detalhe = desfecho.completo
    ? `Pedido #${desfecho.numero_pedido}: todas as ${desfecho.total} linhas PN concluídas`
    : `Pedido #${desfecho.numero_pedido}: ${desfecho.concluidas} de ${desfecho.total} linhas PN concluídas`;

  return (
    <span
      className={cn(
        'inline-flex h-5 shrink-0 items-center gap-0.5 whitespace-nowrap rounded border border-success/30 bg-success/10 px-1.5 text-[10px] font-semibold leading-none text-success',
        className,
      )}
      title={detalhe}
    >
      <span className={cn(desfecho.completo && 'line-through decoration-success decoration-2')}>{texto}</span>
    </span>
  );
}
